import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import React, {useState} from 'react';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import Typography from '@material-ui/core/Typography';

const CamerasDialog = (props) => {
  const { handleType } = props;
  const [actionDisabled, setActionDisabled] = useState(false);

  const titleByType = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ReportProblemIcon style={{ marginRight: 8 }} />
        <Typography>Delete Cameras</Typography>
      </div>
    );
  };

  const contentByType = () => {
    return (
      <>
        <Typography>{'Are you sure want to delete selected physical camera(s)?'}</Typography>
        <Typography color='primary'>All data related to physical camera(s), i.e. VCAMS, will be permanently deleted.</Typography>
      </>
    );
  };

  const actionByType = () => {
    const buttonTxt = (handleType === 'remove') ? 'Delete' : 'Ok';
    return (
      <Button
        autoFocus
        color='primary'
        variant='contained'
        disabled={actionDisabled}
        onClick={() => {
          setActionDisabled(true);
          props.handleOk();
        }}>
        {buttonTxt}
      </Button>
    );
  };

  return (
    <Dialog open={props.open} maxWidth='xs' fullWidth>
      <DialogTitle>{titleByType()}</DialogTitle>
      <DialogContent>
        {contentByType()}
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={props.handleCancel} disabled={actionDisabled}>Cancel</Button>
        {actionByType()}
      </DialogActions>
    </Dialog>
  );
};

export default CamerasDialog;
